// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.flkDK7LGMMv9uJCz2OrD {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0;
  border: 1px solid rgba(255, 255, 255, 0.08);
  /*border-radius: 6px;*/
  /*background: rgba(255, 255, 255, 0.04);*/
  overflow: hidden;
  cursor: grab;
  transition: background 0.12s ease, border-color 0.12s ease;
}

.flkDK7LGMMv9uJCz2OrD:active {
  cursor: grabbing;
}

.flkDK7LGMMv9uJCz2OrD:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.14);
}

/* ── Left accent bar (coloured per format) ───────────────────────────────── */

/* ── Row body ────────────────────────────────────────────────────────────── */

.T0rwf5Dh7ac7kXOTvP59 {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 8px 10px 8px 9px;
}

.SGh0LC5qW2YAT752WGAZ {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  position: relative;
}

.Pw9ZRf9mbHngfJFT9myn {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  color: rgba(251, 252, 246, 0.95);
  font-size: 12px;
  font-weight: 650;
  letter-spacing: 0;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.xJupbX5K3aESTX43gFKK {
  max-width: 100%;
  overflow: hidden;
  color: rgba(251, 252, 246, 0.5);
  font-size: 10.5px;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dW9hWFIdinboYMJaWCTx {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  gap: 5px;
}

.IPMyMC9buu_xQtIAHPeN {
  color: rgba(251, 252, 246, 0.48);
  font-size: 10px;
  line-height: 1;
}

.dG4D9sbnHRI2gEgLYKa2 {
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.09);
  color: rgba(251, 252, 246, 0.6);
  padding: 2px 7px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: 0.2px;
  white-space: nowrap;
}

/* ── Format chip (coloured per format) ───────────────────────────────────── */
.HnBM1GRVaErflQwDugdr {
  max-width: 100%;
  width: 100%;
  text-align: center;
  overflow: hidden;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.68);
  padding: 2px 6px;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.4px;
  line-height: 1;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.yD_6ocYClPuT5Vws_bg8 {
  flex-shrink: 0;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.3px;
  line-height: 1.4;
  text-transform: uppercase;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.12);
  color: rgba(251, 252, 246, 0.8);
}

.gSTIjdbW0w7SnoUoxsuj {

}

._gH0BqykVDK9SsmENtHH {
  width: 52px;
  height: 52px;
}

.dSMga0UBTYIIdW2Inkr6 {
  position: absolute;
  bottom: 4px;
  left: 2px;
  font-size: 7px;
  font-weight: 700;
  letter-spacing: 0.3px;
  padding: 1px 3px;
  border-radius: 3px;
  line-height: 1;
  pointer-events: none;
}

._aYb2vNvaDSmagL3XGZJ { background: color-mix(in srgb, var(--curio-format-geojson-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-geojson-fg) 55%, white); }
.jcMSyRD8H3QsKYIPipM2 { background: color-mix(in srgb, var(--curio-format-csv-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-csv-fg) 55%, white); }
.fcuiZx60FZlDH5AEGBIu { background: color-mix(in srgb, var(--curio-format-json-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-json-fg) 55%, white); }
.RPTn7icr05xfa8zKkvZi { background: color-mix(in srgb, var(--curio-format-parquet-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-parquet-fg) 55%, white); }
.Wm55RBcjP2lyZF_3DJ8Q { background: color-mix(in srgb, var(--curio-format-geotiff-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-geotiff-fg) 55%, white); }
.R8B0asgRZFwAhGHBr6xR { background: color-mix(in srgb, var(--curio-format-shp-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-shp-fg) 55%, white); }
._3GVBCoHf9uR9AoYrzY8 { background: color-mix(in srgb, var(--curio-format-bundle-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-bundle-fg) 55%, white); }
.JerkddFrwd1vzRR3HdOP { background: color-mix(in srgb, var(--curio-format-osm-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-osm-fg) 55%, white); }
.VtyIZq3f_0nwmgAziSvy { background: color-mix(in srgb, var(--curio-format-gpkg-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-gpkg-fg) 55%, white); }
.rD8cMYLMoTBhBG3tXbwR { background: color-mix(in srgb, var(--curio-format-gtfs-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-gtfs-fg) 55%, white); }
.oq5c1I0ocTDEjhy801x8 { background: color-mix(in srgb, var(--curio-format-collection-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-collection-fg) 55%, white); }
.umvRSwmcfDqcIXooBWoM { background: color-mix(in srgb, var(--curio-format-onnx-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-onnx-fg) 55%, white); }
.xth8i7hJ7Pwbe_CTxabX { background: color-mix(in srgb, var(--curio-format-netcdf-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-netcdf-fg) 55%, white); }


/* ── OSM PBF group (collapsible parent + indented member layers) ──────────── */

.N1PmlSP7cGjcPwiRYjMB {
  display: flex;
  flex-direction: column;
}

.XA9yhtw8KPCW1GZU92E0 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
}

/* The meta button highlights linked nodes (like a single dataset row); the icon
   box is the drag handle and the caret button owns expand/collapse. */
.ZlPefkz_VbXUjU5pPktQ {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  padding: 4px 6px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  color: inherit;
  cursor: pointer;
  text-align: left;
}

.ZlPefkz_VbXUjU5pPktQ:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.08);
}

.PYgFt8RwkE7ctrZBTVc4 {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  align-self: stretch;
  padding: 0;
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
}

.AHRskjEXQ_nDQx7tTEkb {
  font-size: 11px;
  color: rgba(251, 252, 246, 0.6);
}

.PYgFt8RwkE7ctrZBTVc4:hover .AHRskjEXQ_nDQx7tTEkb {
  color: rgba(251, 252, 246, 0.95);
}

/* Indented member layers with a coloured left accent bar tying them to the
   parent group. */
.jSYaK8vxbf3eu95EbmSB {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 4px 0 2px 12px;
  padding-left: 10px;
  border-left: 2px solid rgba(76, 175, 114, 0.55);
}


/* "Installing…" placeholder row — subdued + non-interactive while in flight. */
.JU0EjdDu1phBsX4FUR7W {
  opacity: 0.65;
  cursor: default;
}

/* Copy-the-reference, at the end of a palette row (#206). Sized to the row's
   existing meta chips so it does not change the row's height. */
.HuESfDhm8abKaquZzV4r {
    flex-shrink: 0;
    align-self: center;
    margin-left: auto;
}

.kmkjmD1Fui0RLEBDjO90 {
    flex-shrink: 0;
    align-self: center;
    margin-left: 4px;
}

/* The row's own title and id, not the shared one-line palette label: in about
   195 px an ordinary title lost its last word and the id its @version (#527).
   The Node and Agent palettes keep .packageKindRowLabel as it is. */
.bIhrLjO13SNoXgC_hIaK {
  max-width: 100%;
  font-size: 11px;
  font-weight: 600;
  color: rgba(251, 252, 246, 0.92);
  line-height: 1.2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  overflow-wrap: anywhere;
}

.gnTgTXHmRq9vGIhBLDDJ {
  width: 100%;
  font-size: 11px;
  color: var(--curio-text-meta);
  /* Breaks come from the <wbr> after each "." and before "@"; this only
     catches a single segment longer than the row. */
  overflow-wrap: anywhere;
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/nodes/datasetPalette/DatasetPaletteRows.module.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,MAAM;EACN,2CAA2C;EAC3C,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;EACZ,0DAA0D;AAC5D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA,+EAA+E;;AAE/E,+EAA+E;;AAE/E;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;;AAEA;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA,wBAAgB,+EAA+E,EAAE,oEAAoE,EAAE;AACvK,wBAAY,2EAA2E,EAAE,gEAAgE,EAAE;AAC3J,wBAAa,4EAA4E,EAAE,iEAAiE,EAAE;AAC9J,wBAAgB,+EAA+E,EAAE,oEAAoE,EAAE;AACvK,wBAAgB,+EAA+E,EAAE,oEAAoE,EAAE;AACvK,wBAAY,2EAA2E,EAAE,gEAAgE,EAAE;AAC3J,wBAAe,8EAA8E,EAAE,mEAAmE,EAAE;AACpK,wBAAY,2EAA2E,EAAE,gEAAgE,EAAE;AAC3J,wBAAa,4EAA4E,EAAE,iEAAiE,EAAE;AAC9J,wBAAa,4EAA4E,EAAE,iEAAiE,EAAE;AAC9J,wBAAmB,kFAAkF,EAAE,uEAAuE,EAAE;AAChL,wBAAa,4EAA4E,EAAE,iEAAiE,EAAE;AAC9J,wBAAe,8EAA8E,EAAE,mEAAmE,EAAE;;;AAGpK,gFAAgF;;AAEhF;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;sEACsE;AACtE;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;kBACkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,+CAA+C;AACjD;;;AAGA,+EAA+E;AAC/E;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;gEACgE;AAChE;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;oEAEoE;AACpE;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B;oDACkD;EAClD,uBAAuB;AACzB","sourcesContent":["\n.row {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  gap: 0;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  /*border-radius: 6px;*/\n  /*background: rgba(255, 255, 255, 0.04);*/\n  overflow: hidden;\n  cursor: grab;\n  transition: background 0.12s ease, border-color 0.12s ease;\n}\n\n.row:active {\n  cursor: grabbing;\n}\n\n.row:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.14);\n}\n\n/* ── Left accent bar (coloured per format) ───────────────────────────────── */\n\n/* ── Row body ────────────────────────────────────────────────────────────── */\n\n.rowBody {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  padding: 8px 10px 8px 9px;\n}\n\n.rowTop {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  min-width: 0;\n  position: relative;\n}\n\n.rowTitle {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  color: rgba(251, 252, 246, 0.95);\n  font-size: 12px;\n  font-weight: 650;\n  letter-spacing: 0;\n  line-height: 1.2;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rowSource {\n  max-width: 100%;\n  overflow: hidden;\n  color: rgba(251, 252, 246, 0.5);\n  font-size: 10.5px;\n  line-height: 1.2;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rowMeta {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  gap: 5px;\n}\n\n.rowMetaText {\n  color: rgba(251, 252, 246, 0.48);\n  font-size: 10px;\n  line-height: 1;\n}\n\n.connBadge {\n  flex-shrink: 0;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.09);\n  color: rgba(251, 252, 246, 0.6);\n  padding: 2px 7px;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1.3;\n  letter-spacing: 0.2px;\n  white-space: nowrap;\n}\n\n/* ── Format chip (coloured per format) ───────────────────────────────────── */\n.typePill {\n  max-width: 100%;\n  width: 100%;\n  text-align: center;\n  overflow: hidden;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.68);\n  padding: 2px 6px;\n  font-size: 8px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  line-height: 1;\n  text-overflow: ellipsis;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.formatChip {\n  flex-shrink: 0;\n  border-radius: 4px;\n  padding: 2px 6px;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.3px;\n  line-height: 1.4;\n  text-transform: uppercase;\n  white-space: nowrap;\n  background: rgba(255, 255, 255, 0.12);\n  color: rgba(251, 252, 246, 0.8);\n}\n\n.datasetDragIcon {\n\n}\n\n.datasetRowDrag {\n  width: 52px;\n  height: 52px;\n}\n\n.iconBadge {\n  position: absolute;\n  bottom: 4px;\n  left: 2px;\n  font-size: 7px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  padding: 1px 3px;\n  border-radius: 3px;\n  line-height: 1;\n  pointer-events: none;\n}\n\n.chip_geojson { background: color-mix(in srgb, var(--curio-format-geojson-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-geojson-fg) 55%, white); }\n.chip_csv { background: color-mix(in srgb, var(--curio-format-csv-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-csv-fg) 55%, white); }\n.chip_json { background: color-mix(in srgb, var(--curio-format-json-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-json-fg) 55%, white); }\n.chip_parquet { background: color-mix(in srgb, var(--curio-format-parquet-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-parquet-fg) 55%, white); }\n.chip_geotiff { background: color-mix(in srgb, var(--curio-format-geotiff-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-geotiff-fg) 55%, white); }\n.chip_shp { background: color-mix(in srgb, var(--curio-format-shp-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-shp-fg) 55%, white); }\n.chip_bundle { background: color-mix(in srgb, var(--curio-format-bundle-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-bundle-fg) 55%, white); }\n.chip_osm { background: color-mix(in srgb, var(--curio-format-osm-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-osm-fg) 55%, white); }\n.chip_gpkg { background: color-mix(in srgb, var(--curio-format-gpkg-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-gpkg-fg) 55%, white); }\n.chip_gtfs { background: color-mix(in srgb, var(--curio-format-gtfs-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-gtfs-fg) 55%, white); }\n.chip_collection { background: color-mix(in srgb, var(--curio-format-collection-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-collection-fg) 55%, white); }\n.chip_onnx { background: color-mix(in srgb, var(--curio-format-onnx-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-onnx-fg) 55%, white); }\n.chip_netcdf { background: color-mix(in srgb, var(--curio-format-netcdf-fg) 22%, transparent); color: color-mix(in srgb, var(--curio-format-netcdf-fg) 55%, white); }\n\n\n/* ── OSM PBF group (collapsible parent + indented member layers) ──────────── */\n\n.groupBlock {\n  display: flex;\n  flex-direction: column;\n}\n\n.groupHeader {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n/* The meta button highlights linked nodes (like a single dataset row); the icon\n   box is the drag handle and the caret button owns expand/collapse. */\n.groupMetaButton {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 4px;\n  padding: 4px 6px;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  color: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\n.groupMetaButton:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.groupCaretButton {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  align-self: stretch;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n}\n\n.groupCaret {\n  font-size: 11px;\n  color: rgba(251, 252, 246, 0.6);\n}\n\n.groupCaretButton:hover .groupCaret {\n  color: rgba(251, 252, 246, 0.95);\n}\n\n/* Indented member layers with a coloured left accent bar tying them to the\n   parent group. */\n.groupMembers {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 4px 0 2px 12px;\n  padding-left: 10px;\n  border-left: 2px solid rgba(76, 175, 114, 0.55);\n}\n\n\n/* \"Installing…\" placeholder row — subdued + non-interactive while in flight. */\n.installingRow {\n  opacity: 0.65;\n  cursor: default;\n}\n\n/* Copy-the-reference, at the end of a palette row (#206). Sized to the row's\n   existing meta chips so it does not change the row's height. */\n.copyButton {\n    flex-shrink: 0;\n    align-self: center;\n    margin-left: auto;\n}\n\n.detailsButton {\n    flex-shrink: 0;\n    align-self: center;\n    margin-left: 4px;\n}\n\n/* The row's own title and id, not the shared one-line palette label: in about\n   195 px an ordinary title lost its last word and the id its @version (#527).\n   The Node and Agent palettes keep .packageKindRowLabel as it is. */\n.datasetRowTitle {\n  max-width: 100%;\n  font-size: 11px;\n  font-weight: 600;\n  color: rgba(251, 252, 246, 0.92);\n  line-height: 1.2;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  overflow: hidden;\n  overflow-wrap: anywhere;\n}\n\n.datasetRowId {\n  width: 100%;\n  font-size: 11px;\n  color: var(--curio-text-meta);\n  /* Breaks come from the <wbr> after each \".\" and before \"@\"; this only\n     catches a single segment longer than the row. */\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `flkDK7LGMMv9uJCz2OrD`,
	"rowBody": `T0rwf5Dh7ac7kXOTvP59`,
	"rowTop": `SGh0LC5qW2YAT752WGAZ`,
	"rowTitle": `Pw9ZRf9mbHngfJFT9myn`,
	"rowSource": `xJupbX5K3aESTX43gFKK`,
	"rowMeta": `dW9hWFIdinboYMJaWCTx`,
	"rowMetaText": `IPMyMC9buu_xQtIAHPeN`,
	"connBadge": `dG4D9sbnHRI2gEgLYKa2`,
	"typePill": `HnBM1GRVaErflQwDugdr`,
	"formatChip": `yD_6ocYClPuT5Vws_bg8`,
	"datasetDragIcon": `gSTIjdbW0w7SnoUoxsuj`,
	"datasetRowDrag": `_gH0BqykVDK9SsmENtHH`,
	"iconBadge": `dSMga0UBTYIIdW2Inkr6`,
	"chip_geojson": `_aYb2vNvaDSmagL3XGZJ`,
	"chip_csv": `jcMSyRD8H3QsKYIPipM2`,
	"chip_json": `fcuiZx60FZlDH5AEGBIu`,
	"chip_parquet": `RPTn7icr05xfa8zKkvZi`,
	"chip_geotiff": `Wm55RBcjP2lyZF_3DJ8Q`,
	"chip_shp": `R8B0asgRZFwAhGHBr6xR`,
	"chip_bundle": `_3GVBCoHf9uR9AoYrzY8`,
	"chip_osm": `JerkddFrwd1vzRR3HdOP`,
	"chip_gpkg": `VtyIZq3f_0nwmgAziSvy`,
	"chip_gtfs": `rD8cMYLMoTBhBG3tXbwR`,
	"chip_collection": `oq5c1I0ocTDEjhy801x8`,
	"chip_onnx": `umvRSwmcfDqcIXooBWoM`,
	"chip_netcdf": `xth8i7hJ7Pwbe_CTxabX`,
	"groupBlock": `N1PmlSP7cGjcPwiRYjMB`,
	"groupHeader": `XA9yhtw8KPCW1GZU92E0`,
	"groupMetaButton": `ZlPefkz_VbXUjU5pPktQ`,
	"groupCaretButton": `PYgFt8RwkE7ctrZBTVc4`,
	"groupCaret": `AHRskjEXQ_nDQx7tTEkb`,
	"groupMembers": `jSYaK8vxbf3eu95EbmSB`,
	"installingRow": `JU0EjdDu1phBsX4FUR7W`,
	"copyButton": `HuESfDhm8abKaquZzV4r`,
	"detailsButton": `kmkjmD1Fui0RLEBDjO90`,
	"datasetRowTitle": `bIhrLjO13SNoXgC_hIaK`,
	"datasetRowId": `gnTgTXHmRq9vGIhBLDDJ`
};
export default ___CSS_LOADER_EXPORT___;
